<script setup lang="ts">
import { computed } from "vue";

import vLang from "@/directives/lang";
import type { GyldendalReference } from "@/types/article-formats/gyldendal";

import ArticleReference from "./ArticleReference.vue";

const props = defineProps<{
  references: GyldendalReference[];
}>();

const label = computed(() => props.references?.[0].label ?? "Se også");
</script>

<template>
  <p v-if="references.length > 0" class="article-content__text">
    <span class="article-content__label">{{ label }}</span>
    <ArticleReference
      v-for="(reference, index) in references"
      :key="index"
      v-lang:source
      :reference="reference"
      ><template v-if="references.length > index + 1">, </template>
    </ArticleReference>
  </p>
</template>
